<script lang="ts" setup>
  import { UserCircleIcon } from '@heroicons/vue/24/solid'
  import type { ResolvedActivity } from '@/stores'

  const props = defineProps<{
    activityItem: ResolvedActivity
  }>()
  const { activity } = props.activityItem
</script>

<template>
  <div class="relative flex items-start space-x-3">
    <div>
      <div class="relative px-1">
        <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
          <UserCircleIcon
            aria-hidden="true"
            class="h-5 w-5 text-gray-500" />
        </div>
      </div>
    </div>
    <div class="min-w-0 flex-1 py-1.5">
      <div class="text-sm text-gray-500">
        <!--                      <a :href="activityItem.person.href" class="font-medium text-gray-900">{{-->
        <!--                        activityItem.person.name-->
        <!--                      }}</a>-->
        <!--                      {{ ' ' }}-->
        <!--                      assigned-->
        <!--                      {{ ' ' }}-->
        <!--                      <a :href="activityItem.assigned.href" class="font-medium text-gray-900">{{-->
        <!--                        activityItem.assigned.name-->
        <!--                      }}</a>-->
        {{ ' ' }}
        <span class="whitespace-nowrap">{{ $formatter.DateTime(activity!.createdAt!) }}</span>
      </div>
    </div>
  </div>
</template>
